export const ITINERARY_ORIGIN = {
  IB: 'ib',
  DUPLICATE: 'duplicate',
  RESTORE: 'restore',
  IMPORT: 'import',
  WILDERNESS: 'wilderness',
};
